import React, { Component } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }
  return range;
};

const Pagination = ({
  type = 'normal',
  totalRecords = null,
  pageLimit = 30,
  pageNeighbours = 0,
  totalPages,
  fixed = false,
  currentPage,
  onPageChanged = (f) => f,
  changePageNo,
}) => {
  const [pageLimitState] = useState(typeof pageLimit === 'number' ? pageLimit : 30);
  const [totalRecordsState] = useState(typeof totalRecords === 'number' ? totalRecords : 0);
  const [pageNeighboursState] = useState(
    typeof pageNeighbours === 'number' ? Math.max(0, Math.min(pageNeighbours, 2)) : 0,
  );
  const totalPagesState = totalPages;
  useEffect(() => {
    let currentPageState = currentPage;
    if (totalPagesState !== 0 && currentPageState > totalPagesState) {
      currentPageState--;
      changePageNo(currentPageState);
    }
  }, [changePageNo, currentPage, totalPagesState]);
  useEffect(() => {
    // Fetch data for the initial currentPage when the component mounts
    gotoPage(currentPage);
  }, [currentPage]);
  const gotoPage = (page) => {
    const currentPageState = Math.max(0, Math.min(page, totalPagesState));
    if (currentPage === currentPageState) {
      return
    }
    if (page <= totalPages && page > 0) {
      const paginationData = {
        currentPage: currentPageState,
        totalPages: totalPagesState,
        pageLimit: pageLimitState,
        totalRecords: totalRecordsState,
      };

      onPageChanged(paginationData);
    }
  };

  const handleClick = (page) => (evt) => {
    evt.preventDefault();
    gotoPage(page);
  };

  const handleMoveLeft = (evt) => {
    evt.preventDefault();
    gotoPage(currentPage - pageNeighboursState * 2 - 1);
  };

  const handleMoveRight = (evt) => {
    evt.preventDefault();
    gotoPage(currentPage + pageNeighboursState * 2 + 1);
  };

  const fetchPageNumbers = () => {
    const pageNeighbours = pageNeighboursState;
    const totalNumbers = pageNeighbours * 2 + 2;
    const totalBlocks = totalNumbers + 2;

    if (totalPagesState > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPagesState - 1, currentPage + pageNeighbours);

      let pages = range(startPage, endPage);

      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPagesState - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        case hasLeftSpill && !hasRightSpill: {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }
        case !hasLeftSpill && hasRightSpill: {
          const extraPages = range(endPage + 1, endPage + spillOffset);
          pages = [...pages, ...extraPages, RIGHT_PAGE];
          break;
        }
        default: {
          const extraPages = range(endPage + 1, endPage + spillOffset);
          pages = [LEFT_PAGE, ...pages, ...extraPages, RIGHT_PAGE];
          break;
        }
      }

      // return [1, ...pages, totalPages];
      return [1, ...pages, totalPages];
    }

    return range(1, totalPagesState);
  };

  let pages = fetchPageNumbers();
  useEffect(() => {
    pages = fetchPageNumbers();
  }, [totalPages]);
  return (
    <React.Fragment key={totalRecords}>
      {type !== 'Sticky' && (
        <nav aria-label="Countries Pagination" >
          <ul className="pagination">
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <button className="page-link" aria-label="Previous" onClick={handleMoveLeft}>
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </button>
                  </li>
                );

              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <button className="page-link" aria-label="Next" onClick={handleMoveRight}>
                      <span aria-hidden="true">&raquo;</span>
                      <span className="sr-only">Next</span>
                    </button>
                  </li>
                );

              return (
                <li key={index} className={`page-item${currentPage === page ? ' active' : ''}`}>
                  <button className="page-link" onClick={handleClick(page)}>
                    {page}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      )}
      {type === 'Sticky' && (
        <nav aria-label="Countries Pagination" className="Sticky-Pagination" style={{ position: fixed ? "unset" : "absolute" }}>
          <ul className="pagination">
            <li className="page-item page-item-2">
              <button
                className="page-link page-link-2"
                aria-label="Previous"
                onClick={() => gotoPage(currentPage - 1)}
              >
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Previous</span>
              </button>
            </li>
            {pages.map((page, index) => {
              // if (page === LEFT_PAGE)
              //   return (
              //     // <li key={index} className="page-item">
              //     //   <button className="page-link" aria-label="Previous" onClick={handleMoveLeft}>
              //     //     <span aria-hidden="true">&laquo;</span>
              //     //     <span className="sr-only">Previous</span>
              //     //   </button>
              //     // </li>
              //     <></>
              //   );

              // if (page === RIGHT_PAGE)
              //   return (
              //     // <li key={index} className="page-item">
              //     //   <button className="page-link" aria-label="Next" onClick={handleMoveRight}>
              //     //     <span aria-hidden="true">&raquo;</span>
              //     //     <span className="sr-only">Next</span>
              //     //   </button>
              //     // </li>
              //     <></>
              //   );
              if (page !== RIGHT_PAGE && page !== LEFT_PAGE)
                return (
                  <li key={index} className={`page-item ${currentPage === page ? ' active' : ''}`}>
                    <button className="page-link" onClick={handleClick(page)}>
                      {page}
                    </button>
                  </li>
                );
            })}
            <li className="page-item">
              <button
                className="page-link page-link-2"
                aria-label="Next"
                onClick={() => gotoPage(currentPage + 1)}
              >
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Next</span>
              </button>
            </li>
            <li className="d-flex align-items-center">
              <span className="Title-medium" style={{ color: '#929292' }}>
                {currentPage} - {totalPages} of {totalPages}
              </span>
            </li>
          </ul>
          <ul></ul>
        </nav>
      )}
    </React.Fragment>
  );
};

export default Pagination;
